<head>
  <link rel="stylesheet" href="/assets/CSS/navmenu.css">
  <link rel="stylesheet" type="text/css" href="/assets/CSS/rpopup.css" />
  <link rel="stylesheet" type="text/css" href="/assets/CSS/bootstrap.min.css" />
</head>
<body>

  <!-- Navbar -->
  <div class="menu-wrap">
    <input type="checkbox" class="toggler">
    <div class="hamburger"><div></div></div>
    <div class="menu">
      <div>
        <div>
          <ul>
            <li><a href="/home">Home</a></li>
            <li><a href="http://localhost:8000/admin">Admin</a></li>
            <li><a href="/business">My Businesses</a></li>


            <!-- Submit Button -->
            <div *ngIf="show_backup;then content else other_content">here is
              ignored</div>

            <!-- Initial Calculate button -->
            <ng-template #other_content>
              <li><a role="button" (click)="backupData()">Backup Data</a></li>
            </ng-template>
            <!-- Initial Calculate button -->

            <!-- After clicking loading button -->
            <ng-template #content>
              <li><a role="button">Please wait a minute your data is backuping.....</a></li>
              <div class="d-flex justify-content-center">
                <div class="spinner-border text-success" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </ng-template>
            <!-- After clicking loading button -->


            <li><a role="button" (click)="logout()">Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- Navbar -->

</body>

<router-outlet></router-outlet>



<footer>

  <div class="copyright">
    <div class="container">
      <div class="row">
        <span
          style="font-size:large;margin-left:-500px;position:relative;top:40px">
          <a title="vikasjoshis001@gmail.com" onmouseover="" style="cursor: pointer;color:
          red;" href="mailto: crunchbase.io@gmail.com"><i class="material-icons email">&#xe0be;</i>
          </a>
          &nbsp;&nbsp;&nbsp;
          <a title="8805572004" onmouseover="" style="cursor: pointer;color:
          blue;" href="callto: +918805572004"><i class="material-icons call">&#xe0b0;</i>
          </a>
        </span>
        <span>Developed by devMonks.org</span>
        <br>
        <span>Copyright © 2021, All Right Reserved</span>
      </div>

    </div>
  </div>
</footer>